.panel {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.pickerRow {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-3);
}

.pickerName {
  font: var(--t-body-strong);
}

.pencil {
  color: var(--pencil);
  font: var(--t-small);
}

.empty {
  margin: 0;
  color: var(--graphite);
}

.line {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding: var(--space-4) 0;
  border-top: 1px solid var(--rule);
}

.lineHeader {
  display: flex;
  align-items: baseline;
  gap: var(--space-3);
}

.lineTitle {
  margin: 0;
  font: var(--t-heading);
}

.lineHeader > :last-child {
  margin-left: auto;
}

.fields {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: var(--space-4);
}

.passive {
  margin: 0;
  padding: 0;
  list-style: none;
  color: var(--graphite);
  font: var(--t-small);
}

.passive li::before {
  content: '— ';
}

.alertDetail {
  margin: 0;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--space-4);
  border-top: 1px solid var(--rule);
  padding-top: var(--space-4);
}

.status {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.foot {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.list {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.rx {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-top: var(--space-3);
  border-top: 1px solid var(--rule);
}

.rxHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-3);
}

.rxHeader > :last-child {
  margin-left: auto;
}

.rxLine {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-3);
}

.rxLine[data-inactive] .sig {
  color: var(--pencil);
  text-decoration: line-through;
}

.sig {
  flex: 1 1 320px;
}

.printArea {
  position: absolute;
  left: -10000px;
  top: 0;
}

/* The prescription print dialog: the button first, then the A5 preview. The dialog is
   narrower than A5, so on screen the preview scrolls sideways inside itself instead of
   being cut off; printing ignores this and uses the sheet's own size. */
.printer {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-4);
  min-width: 0;
}

@media screen {
  .preview {
    max-width: 100%;
    overflow-x: auto;
    border: 1px solid var(--rule);
  }
}
